import React from 'react'
import MessageUI from '../../widgets/output/MessageUI'
import PrivatePageSF from '../../templates/PrivatePageSF'
import PageTitleUI from '../../widgets/output/PageTitleUI'
import ViewOrUpdateSF from '../../widgets/layout/ViewOrUpdateSF'
import LRTableBodyUI from '../../widgets/layout/LRTableBodyUI'
import LRTableRowLinkUI from '../../widgets/layout/LRTableRowLinkUI'
import GenericErrorUI from '../../components/common/GenericErrorUI'
import EmailViewUI from '../../components/userSettings/EmailViewUI'
import EmailUpdateSF from '../../components/userSettings/EmailUpdateSF'
import NameViewUI from '../../components/userSettings/NameViewUI'
import NameUpdateSF from '../../components/userSettings/NameUpdateSF'
import AvatarViewUI from '../../components/userSettings/AvatarViewUI'
import AvatarInfoUI from '../../components/userSettings/AvatarInfoUI'
import PasswordViewUI from '../../components/userSettings/PasswordViewUI'
import PinCodeViewUI from '../../components/userSettings/PinCodeViewUI'
import PinCodeUpdateSF from '../../components/userSettings/PinCodeUpdateSF'
import SpinnerComponentUI from '../../components/common/SpinnerComponentUI'
import PasswordUpdateSF from '../../components/userSettings/PasswordUpdateSF'
import PasswordExternalUI from '../../components/userSettings/PasswordExternalUI'
import PaymentCardUI from '../../components/accountSettings/paymentCard/PaymentCardUI'
import './UserSettingsPage.css'

const UserSettingsFinPageUI = ({ context, user, paymentCard, messageList, errorList,
  onEmailUpdated, onNameUpdated, onPhoneUpdated, onEmailAcceptanceUpdated
}) =>

  <PrivatePageSF context={context} className='pg_user_st_fin' backLink='/settings' centered={!user}
    messageList={messageList} headerMessageKey='c_user_settings'>
    {
      !user &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      user &&
      <div>
        <PageTitleUI context={context} goBack={true} backLink='/settings' messageList={messageList} titleMessageKey='c_user_settings' />

        <LRTableBodyUI context={context} className='menu'>

          <LRTableRowLinkUI
            context={context}
            to='/settings/user/phone'
            left={<label><MessageUI messageList={messageList} messageKey='c_phone_number' /></label>}
            right={<div className="g_flex_h">{user.phoneNumber}<div className="icon icon-caret-right g_m_left_50"></div></div>}
          />

          <ViewOrUpdateSF context={context} messageList={messageList} labelMessageKey='c_email'
            rightViewUI={<EmailViewUI context={context} messageList={messageList} email={user.email} />}
            updateUI={<EmailUpdateSF context={context} messageList={messageList} email={user.email} onUpdateComplete={onEmailUpdated} />}
          />

          <ViewOrUpdateSF context={context} messageList={messageList} labelMessageKey='c_name'
            rightViewUI={<NameViewUI context={context} messageList={messageList} firstName={user.firstName} lastName={user.lastName} />}
            updateUI={<NameUpdateSF context={context} messageList={messageList} firstName={user.firstName} lastName={user.lastName} onUpdateComplete={onNameUpdated} />}
          />

          <ViewOrUpdateSF context={context} messageList={messageList} labelMessageKey='c_photo'
            rightViewUI={<AvatarViewUI context={context} messageList={messageList} avatarUrl={user.avatarUrl} />}
            updateUI={<AvatarInfoUI context={context} messageList={messageList} avatarUrl={user.avatarUrl} email={user.email} />}
          />

          {
            context.session.authMethod === 'email_password' &&
            <ViewOrUpdateSF context={context} messageList={messageList} labelMessageKey='c_password'
              rightViewUI={<PasswordViewUI context={context} messageList={messageList} />}
              updateUI={user.identityProvider ?
                <PasswordExternalUI context={context} messageList={messageList} identityProvider={user.identityProvider} />
                :
                <PasswordUpdateSF context={context} messageList={messageList} />
              }
            />
          }

          {
            context.session.authMethod === 'phone_pin' &&
            <ViewOrUpdateSF context={context} messageList={messageList} labelMessageKey='c_pin_code'
              rightViewUI={<PinCodeViewUI context={context} messageList={messageList} />}
              updateUI={<PinCodeUpdateSF context={context} messageList={messageList} />}
            />
          }

          <ViewOrUpdateSF context={context} messageList={messageList} labelMessageKey='c_payment_card'
            rightViewUI={<div>{paymentCard ? paymentCard.description : ''}</div>}
            updateUI={
              <PaymentCardUI context={context} messageList={messageList} paymentCard={paymentCard} />
            }
          />

          {/*
          <LRTableRowUI
            context={context}
            left={<label><MessageUI messageList={messageList} messageKey='c_email_notifications' /></label>}
            right={<EmailAcceptanceUpdateSF context={context} messageList={messageList} emailAcceptance={user.emailAcceptance} onUpdateComplete={onEmailAcceptanceUpdated} />}
          />
          */}

          <LRTableRowLinkUI
            context={context}
            to='/settings/user/teams'
            left={<label><MessageUI messageList={messageList} messageKey='c_connected_accounts' /></label>}
            right={<div className="icon icon-caret-right"></div>}
          />

          <LRTableRowLinkUI
            context={context}
            to='/settings/user/notifications'
            left={<label><MessageUI messageList={messageList} messageKey='c_email_notifications' /></label>}
            right={<div className="icon icon-caret-right"></div>}
          />

        </LRTableBodyUI>
      </div>
    }
  </PrivatePageSF>

export default UserSettingsFinPageUI
